module.exports = __webpack_public_path__ + "img/huaian_s.78b022d.png";